/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Sticky Table of Contents for posts */
(function () {
    if (!document.body.classList.contains('post-template')) return;

    var content = document.querySelector('.gh-content');
    var toc = document.getElementById('gh-toc');
    if (!content || !toc) return;

    var headings = content.querySelectorAll('h2[id]');
    if (headings.length < 3) {
        toc.remove();
        return;
    }

    var nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Table of contents');
    var title = document.createElement('div');
    title.className = 'gh-toc-title';
    title.textContent = 'Contents';
    nav.appendChild(title);

    var list = document.createElement('ul');
    for (var i = 0; i < headings.length; i++) {
        var h = headings[i];
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
    }
    nav.appendChild(list);
    toc.appendChild(nav);

    /* Highlight current section on scroll */
    var links = toc.querySelectorAll('a');
    var headingOffsets = [];

    function updateOffsets() {
        headingOffsets = [];
        for (var j = 0; j < headings.length; j++) {
            headingOffsets.push(headings[j].getBoundingClientRect().top + window.scrollY - 120);
        }
    }

    function highlightCurrent() {
        var scrollPos = window.scrollY;
        var current = 0;
        for (var j = 0; j < headingOffsets.length; j++) {
            if (scrollPos >= headingOffsets[j]) {
                current = j;
            }
        }
        for (var k = 0; k < links.length; k++) {
            links[k].classList.toggle('is-active', k === current);
        }
    }

    updateOffsets();
    highlightCurrent();
    window.addEventListener('scroll', highlightCurrent, { passive: true });
    window.addEventListener('resize', function () { updateOffsets(); highlightCurrent(); }, { passive: true });
})();

/* Accordion FAQ sections */
(function () {
    if (!document.body.classList.contains('post-template')) return;

    var content = document.querySelector('.gh-content');
    if (!content) return;

    /* Find the FAQ heading (H2 containing "FAQ" or "Frequently Asked") */
    var faqHeading = null;
    var h2s = content.querySelectorAll('h2');
    for (var i = 0; i < h2s.length; i++) {
        var text = h2s[i].textContent.toLowerCase();
        if (text.indexOf('faq') !== -1 || text.indexOf('frequently asked') !== -1) {
            faqHeading = h2s[i];
            break;
        }
    }
    if (!faqHeading) return;

    /* Collect H3 + content pairs after the FAQ heading */
    var items = [];
    var el = faqHeading.nextElementSibling;
    var currentQ = null;
    var currentContent = [];

    while (el && el.tagName !== 'H2') {
        if (el.tagName === 'H3') {
            if (currentQ) {
                items.push({ question: currentQ, content: currentContent });
            }
            currentQ = el.textContent;
            currentContent = [];
        } else if (currentQ) {
            currentContent.push(el);
        }
        el = el.nextElementSibling;
    }
    if (currentQ) {
        items.push({ question: currentQ, content: currentContent });
    }

    if (items.length === 0) return;

    /* Build the accordion */
    var accordion = document.createElement('div');
    accordion.className = 'gh-accordion';

    for (var j = 0; j < items.length; j++) {
        var item = items[j];
        var details = document.createElement('details');
        details.className = 'gh-accordion-item';

        var summary = document.createElement('summary');
        summary.className = 'gh-accordion-question';
        summary.textContent = item.question;
        details.appendChild(summary);

        var answer = document.createElement('div');
        answer.className = 'gh-accordion-answer';
        for (var k = 0; k < item.content.length; k++) {
            answer.appendChild(item.content[k]);
        }
        details.appendChild(answer);
        accordion.appendChild(details);
    }

    /* Remove original H3s and their content, replace with accordion */
    var removeFrom = faqHeading.nextElementSibling;
    while (removeFrom && removeFrom.tagName !== 'H2' && removeFrom !== accordion) {
        var next = removeFrom.nextElementSibling;
        if (!accordion.contains(removeFrom)) {
            removeFrom.remove();
        }
        removeFrom = next;
    }
    faqHeading.insertAdjacentElement('afterend', accordion);

    /* Inject FAQ structured data if not already present */
    var existingFaq = document.querySelector('script[type="application/ld+json"]');
    var hasFaqSchema = false;
    var ldScripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var s = 0; s < ldScripts.length; s++) {
        if (ldScripts[s].textContent.indexOf('FAQPage') !== -1) {
            hasFaqSchema = true;
            break;
        }
    }

    if (!hasFaqSchema && items.length > 0) {
        var faqSchema = {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            'mainEntity': []
        };
        for (var m = 0; m < items.length; m++) {
            var answerText = '';
            var answerEl = accordion.querySelectorAll('.gh-accordion-item')[m];
            if (answerEl) {
                answerText = answerEl.querySelector('.gh-accordion-answer').textContent.trim();
            }
            faqSchema.mainEntity.push({
                '@type': 'Question',
                'name': items[m].question,
                'acceptedAnswer': {
                    '@type': 'Answer',
                    'text': answerText
                }
            });
        }
        var schemaScript = document.createElement('script');
        schemaScript.type = 'application/ld+json';
        schemaScript.textContent = JSON.stringify(faqSchema);
        document.head.appendChild(schemaScript);
    }
})();